<template>
  <v-card :key="invoice.number"
          elevation="1"  
          rounded
          class="mb-2 pa-1"           
  >  
    <v-row dense class="ma-1">
      <template v-if="$vuetify.breakpoint.mdAndUp">
        <v-col cols="2" class="text-uppercase font-weight-bold align-self-center">
          {{ invoice.number }}
        </v-col>
        <v-col cols="2" class="text-uppercase font-weight-bold align-self-center">
          {{ invoice.date|longPaperDateYear }}          
        </v-col>
        <v-col cols="2" class="text-uppercase font-weight-bold align-self-center">
          {{ invoice.dueDate|longPaperDateYear }} 
        </v-col>                
        <v-col cols="2" class="align-self-center">
          {{ invoice.amount|toCurrency }}
        </v-col>      
        <v-col cols="2" class="text-uppercase align-self-center">
          {{ invoice.status }} 
        </v-col>        
        <v-spacer />  
        <v-col cols="2">          
          <v-btn small :loading="loading" @click="getFile()"> 
            Ladda ner
          </v-btn>
        </v-col>
        
        
        <!-- <v-spacer v-if="$vuetify.breakpoint.mdAndUp" />         -->
      </template>
      <template v-else>
        <v-container>
          <v-row dense>            
            <v-col cols="3" justify="end" class="text-uppercase font-weight-bold align-self-center">
              <div class="text-xs-caption">
                Fakturanr:
              </div>
              {{ invoice.number }}               
            </v-col>
            <v-col cols="3" class="font-weight-bold align-self-center">
              {{ invoice.amount|toCurrency }}
            </v-col>
            <v-col cols="3" class="font-weight-bold align-self-center">
              {{ invoice.status }}
            </v-col>
            <v-col cols="3" class="font-weight-bold">                                       
              <v-btn small :loading="loading" @click="getFile()"> 
                Ladda ner
              </v-btn>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="3">             
              {{ invoice.date|paperDateYear }}          
            </v-col>
            <v-col cols="3">              
              {{ invoice.dueDate|paperDateYear }}          
            </v-col>
          </v-row>     
        </v-container>   
      </template>
    </v-row>             
    <v-snackbar      
      v-model="snackbar"
      :vertical="vertical"
      color="red accent-2"
    >
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn         
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import api from '@/backend/api'
export default {
  name: 'Invoice', 
   props: {
    invoice: {
      type: Object,
      required: true,
    },
    paper:{
      type: String,
      required: true
    }
  }, 
  data(){
    return {
      loading:false,
      snackbar: false,
      text:'',
      vertical:true
    }
  },      
  methods:{
    getFile(){
      this.loading = true
      api.getInvoice(this.paper,this.invoice.number).then(resp =>{                    
        this.handleFileRepsonse(this.invoice.number,resp)
      })                    
    },
    handleFileRepsonse(id,resp){
    
      if(resp.data === null || resp.data === undefined || resp.data === '')
      {
        this.text = 'Gick inte att ladda ner faktura\n '+id
        this.snackbar = true
      }else{
        var link = document.createElement('a')
        link.href = 'data:application/octet-stream;base64,' + resp.data
        link.target = '_blank'
        link.download = id + '.pdf'
        link.click()
      }      
      this.loading= false
    }
  }
}
</script>